// @ts-nocheck
import Events from '../constants/events';
import store from '../store';

export default new Proxy(
  {
    events: Object.fromEntries(
      Object.entries(Events).filter(([, value]) =>
        value.startsWith('concord-profile'),
      ),
    ),
  },
  {
    get: (obj, prop) => {
      if (prop === 'id') {
        return store.config.projectId;
      }
      return Reflect.get(obj, prop);
    },
    set: () => false,
  },
);
